var avatarClickHandler = null;
var avatarKeydownHandler = null;
var avatarTriggerClickHandler = null;

document.addEventListener("turbo:load", initMobileWebAiAvatarMenu);

function initMobileWebAiAvatarMenu() {
  if (!document.body.classList.contains("mobile-web-ai")) return;

  var trigger = document.getElementById("mwai-avatar-trigger");
  var dropdown = document.getElementById("mwai-avatar-dropdown");

  if (!trigger || !dropdown) return;

  if (avatarTriggerClickHandler) {
    trigger.removeEventListener("click", avatarTriggerClickHandler);
  }
  avatarTriggerClickHandler = function (e) {
    e.preventDefault();
    e.stopPropagation();

    var calPickerDropdown = document.getElementById("mwai-calendar-picker-dropdown");
    if (calPickerDropdown) calPickerDropdown.classList.remove("active");

    dropdown.classList.toggle("active");
  };
  trigger.addEventListener("click", avatarTriggerClickHandler);

  if (avatarClickHandler) {
    document.removeEventListener("click", avatarClickHandler);
  }
  avatarClickHandler = function (e) {
    if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.classList.remove("active");
    }
  };
  document.addEventListener("click", avatarClickHandler);

  if (avatarKeydownHandler) {
    document.removeEventListener("keydown", avatarKeydownHandler);
  }
  avatarKeydownHandler = function (e) {
    if (e.key === "Escape" && dropdown.classList.contains("active")) {
      dropdown.classList.remove("active");
    }
  };
  document.addEventListener("keydown", avatarKeydownHandler);
}

document.addEventListener("turbo:before-cache", function () {
  var dropdown = document.getElementById("mwai-avatar-dropdown");
  if (dropdown) dropdown.classList.remove("active");
});
